import React from 'react'

import PODocumentsOutlet from '@/components/views/ci/PO/PODocumentsOutlet'

const PO_PODocumentsOutlet = () => {
    return <PODocumentsOutlet />
}

export default PO_PODocumentsOutlet
